import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    $('.autocomplete').autocomplete({
      source(request, response) {
        $.ajax({
          url: '/u/admin/items/xhr_user_emails',
          data: {
            email: request.term,
          },
          success(data) {
            response(data);
          },
        });
      },
      minLength: 2,
    });
  });
});
